module.exports = __EurekaManagers__.default;